import { notification } from "antd";
import { getAxios } from "../axiosWithToken";

export const getAllRaces = () => getAxios().get(`races/races/`);
export const getRaceBySlug = slug => getAxios().get(`races/races/${slug}/`);
export const getRaceDetailByRace = id =>
  getAxios().get(`races/races-detail?race=${id}`);

export const getAddonByRace = id =>
  getAxios().get(`addons/addons?race=${id}&is_close=false`);

export const postPayment = body =>
  getAxios()
    .post(`payments/payments/`, body)
    .catch(e => {
      notification.error({
        message: Object.entries(e.response.data)
          .map(x => x.join(":"))
          .join("\r\n")
      });
      return Promise.reject(e);
    });

export const postRun = body =>
  getAxios()
    .post(`participants/runs/`, body)
    .catch(e => {
      notification.error({ message: "เกิดข้อผิดพลาด" });
      return Promise.reject(e);
    });



// WEBPACK FOOTER //
// /opt/build/repo/src/api/async/index.js